module.exports = __webpack_public_path__ + "img/111.855fbdc (1).855fbdc6.png";